//service.js
import { data } from 'jquery';
import service from './axios'

// 会员登录
export const Login = data => {
	return service({
		url: '/review/login',
		method: 'post',
		data
	})
};
// 用户信息
export const GetMember = data => {
	return service({
		url: '/info',
		method: 'get',
		data
	})
};

//奖项列表
export const expertaward = (data) => {
	return service({
		url: '/review/award',
		method: 'GET',
		data
	})
};
// 专家登录信息
export const expertinfo = data => {
	return service({
		url: '/review/info',
		method: 'get',
		data
	})
};
// 更新用户信息
export const UpdataMember = data => {
	return service({
		url: '/user',
		method: 'PUT',
		data:data
	})
};
// 奖项管理列表
export const PrizeList = data => {
	console.log(data)
	return service({
		url: '/prize',
		method: 'get',
		data
	})
};

// 奖项列表
export const AwardList = data => {
	return service({
		url: '/award',
		method: 'GET',
		data
	})
};
// 申报记录详情
export const AwardInfo = id => {
	return service({
		url: '/award_log/' + id,
		method: 'GET',
	})
};
export const AwardInfoList = data => {
	return service({
		url: '/award_log',
		method: 'GET',
		data
	})
};

export const AwardBatches = id => {
	return service({
		url: '/review/award/getbatches/'+id,
		method: 'GET',
	})
};

export const AwardBatchList = id => {
	return service({
		url: '/review/award/getbatches/'+id,
		method: 'GET',
	})
};

export const avgdistruct = (id,data) => {
	return service({
		url: '/review/award/avgdistruct/'+id,
		method: 'POST',
		data
	})
};

export const gfdistribute = (id,data) => {
	return service({
		url: '/review/award/gfdistribute/'+id,
		method: 'POST',
		data
	})
};

// 申报奖项
export const AwardLog = data => {
	return service({
		url: '/award_log',
		method: 'POST',
		data
	})
};
export const getExpert = data => {
    return service({
        url: '/review/expert',
        method: 'GET',
        data
    })
};
export const setExpert = (id,data) => {
    return service({
        url: '/review/award/distribute/'+id,
        method: 'POST',
        data
    })
};
//专家端奖项评审列表
export const expertawardlogs = id => {
	return service({
		url: '/expert/award/logs/'+id,
		method: 'GET'
	})
};
//专家端评审记录详情列表
export const expertverifyLogs = (id,data) => {
	return service({
		url: '/expert/award/verifyLogs/'+id,
		method: 'GET',
		data
	})
};
//专家端评审审核是否通过
export const expertverify = (data,id) => {
	return service({
		url: '/review/award/verify/'+id,
		method: 'POST',
		data
	})
};



export const expertgfbverify = (data,ids) => {
	return service({
		url: '/review/award/gfbverify/'+ids,
		method: 'POST',
		data
	})
};

export const expertgfverify = (data,id) => {
	return service({
		url: '/review/award/gfverify/'+id,
		method: 'POST',
		data
	})
};

export const adminRejectAwardLog = (id, data) => {
	return service({
		url: '/review/award/admin_reject/' + id,
		method: 'POST',
		data
	})
};

export const exportOpinionPdfs = (ids) => {
	return service({
		url: '/review/award/export_opinion_pdfs',
		method: 'POST',
		data: { ids },
		responseType: 'blob'
	})
};

export const batchExportScore = (ids) => {
	return service({
		url: '/review/award/batch_export_score',
		method: 'POST',
		data: {
			ids
		},
		responseType: 'blob'
	})
};

export const exportScoreByBatch = (batch_id, wtype) => {
	return service({
		url: '/review/award/export_score_by_batch/' + batch_id,
		method: 'GET',
		params: { wtype },
		responseType: 'blob'
	})
};

export const exportSummaryByBatch = (batch_id, wtype) => {
	return service({
		url: '/review/award/export_summary/' + batch_id,
		method: 'GET',
		params: { wtype },
		responseType: 'blob'
	})
};

// 保存工法评审意见（待后端联调确认 review 端最终接口）
export const saveopinion = (id, data) => {
	return service({
		url: '/review/award/saveopinions/' + id,
		method: 'POST',
		data
	})
};

// 组长退回初审（待后端联调确认最终接口）
export const returnInitialReview = (id, data) => {
	return service({
		url: '/review/award/return_initial/' + id,
		method: 'POST',
		data
	})
};

//第二次提交奖项资料
export const submitFile = (data,id) => {
	return service({
		url: '/award_log/submitFile/'+id,
		method: 'POST',
		data
	})
};

export const getBatchWtypeExperts =  (id,data)  => {
    return service({
        url: '/review/award/get_batch_wtype_experts/'+id,
        method: 'GET',
        data
    })
};

export const checkedlogs =  (id)  => {
    return service({
        url: '/review/award/checkedlogs/'+id,
        method: 'GET'
    })
};

export const batchinfo =  (id)  => {
    return service({
        url: '/review/award/batchinfo/'+id,
        method: 'GET',
    })
};

export const setexpertchecked =  (id,data)  => {
    return service({
        url: '/review/award/setexpertchecked/'+id,
        method: 'POST',
        data
    })
};

export const getdistributeinfo =  (id,data)  => {
    return service({
        url: '/review/award/getdistributeinfo/'+id,
        method: 'GET',
        data
    })
};

// 前台管理员退回企业修改（待后端联调确认最终接口）
export const returnAwardLog = (id, data) => {
	return service({
		url: '/review/award_log/return/' + id,
		method: 'POST',
		data
	})
};

// 查询退回短信失败原因（待后端联调确认最终接口）
export const getReturnSmsReason = (id) => {
	return service({
		url: '/review/award_log/' + id + '/sms_reason',
		method: 'GET'
	})
};
